import React, { useEffect } from "react";
import Link from "next/link";

const Answers = ({ data, topicId, topicItem }) => {
  useEffect(() => {
    if (
      document
        ?.getElementsByClassName("answer-wrapper")?.[0]
        ?.getElementsByTagName("img")?.length > 0
    ) {
      document
        .getElementsByClassName("answer-wrapper")[0]
        .getElementsByTagName("img")[0].style.width = "100%";
    }
  }, [topicItem]);

  return (
    <div className="answer-container">
      {data &&
        data.map((i, key) => (
          <div key={key}>
            {topicItem === i.key ? (
              <>
                <h2 className="answer-header">{i.question}</h2>
                <div
                  className="answer-wrapper"
                  dangerouslySetInnerHTML={{ __html: i.answer }}
                ></div>
                {i?.iframe && (
                  <div
                    className="iframe-content"
                    dangerouslySetInnerHTML={{ __html: i?.iframe }}
                  ></div>
                )}
                <div className="question-more">
                  <hr className="question-more-separator" />
                  <h3>Pertanyaan terkait</h3>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        ))}
      {data &&
        data.map((i, key) => (
          <div key={key}>
            {topicItem !== i.key ? (
              <>
                <li className="question-list">
                  <Link
                    key={key}
                    href="/pertanyaan-umum/[topicId]/[topicItem]"
                    as={`/pertanyaan-umum/${topicId.replace(
                      /_/g,
                      "-"
                    )}/${i.key.replace(/_/g, "-")}`}
                    legacyBehavior
                  >
                    <a>{i.question}</a>
                  </Link>
                </li>
                <hr className="question-list-more-separator" />
              </>
            ) : (
              ""
            )}
          </div>
        ))}

      <style jsx global>{`
        .answer-wrapper li {
          margin-left: 40px;
        }

        .answer-wrapper ul {
          list-style-type: disc;
        }

        .answer-wrapper a {
          color: var(--color-red);
        }

        .answer-wrapper img {
          width: 100%;
        }

        @media only screen and (max-width: 600px) {
          .iframe-content iframe {
            width: 100%;
            height: 54vw;
          }
        }

        @media only screen and (min-width: 601px) and (max-width: 1000px) {
          .iframe-content iframe {
            width: 55vw;
            height: 31vw;
          }
        }
      `}</style>
      <style jsx>{`
        .iframe-content {
          width: 100%;
          margin: 25px 0;
          text-align: center;
        }

        .answer-header {
          font-weight: bold;
        }

        .answer-wrapper figure img {
          width: 100%;
        }

        .question-list {
          color: var(--color-gray);
          list-style-type: none;
          font-size: 16px;
          line-height: 23px;
          margin: 0 0 16px 0;
        }

        .question-more {
          margin: 16px 0;
        }

        .question-list-more-separator {
          display: none;
        }

        .question-more-separator {
          display: block;
          border: 1px solid var(--color-white-soft);
          margin: 24px 0;
        }

        @media only screen and (max-width: 600px) {
          .question-more {
            margin: 32px 0 16px 0;
          }

          .question-more-separator {
            display: none;
          }

          .question-list-more-separator {
            display: block;
            border: 1px solid var(--color-white-soft);
          }

          .question-list {
            margin: 16px 0;
          }
        }
      `}</style>
    </div>
  );
};
export default Answers;
